import { useState, createContext, useContext } from 'react'
import { AppContentQueryResponse } from './types'

type AppContentState = {
  promotionalBanner: string | null
  logoImage: string
  altLogoImage: string
  bannerImage: string
  splashImage: string
  setAppContent: (content: AppContentQueryResponse) => void
}

export const SetupAppContent = (): AppContentState => {
  const [promotionalBanner, setPromotionalBanner] = useState<string | null>(
    null
  )
  const [logoImage, setLogoImage] = useState<string>('')
  const [altLogoImage, setAltLogoImage] = useState<string>('')
  const [bannerImage, setBannerImage] = useState<string>('')
  const [splashImage, setSplashImage] = useState<string>('')

  const setAppContent = (content: AppContentQueryResponse) => {
    setPromotionalBanner(content?.promotionalBanner || null)
    setLogoImage(content?.altLogoImage || content?.logoImage)
    setAltLogoImage(content?.logoImage || content?.altLogoImage)
    setBannerImage(content?.shop?.header?.bannerImage)
    setSplashImage(content?.splashImage)
  }

  return {
    promotionalBanner,
    logoImage,
    altLogoImage,
    bannerImage,
    splashImage,
    setAppContent
  }
}

const initialState: AppContentState = {
  promotionalBanner: null,
  logoImage: '',
  altLogoImage: '',
  bannerImage: '',
  splashImage: '',
  setAppContent: () => {}
}

export const AppContentContext = createContext<AppContentState>(initialState)

export const useAppContent = () => {
  return useContext(AppContentContext)
}
